import React from "react";

export type ScreeningLoaderProps = {};

const ScreeningLoader: React.FC<ScreeningLoaderProps> = () => {
  return <div>Loading...</div>;
};

export default ScreeningLoader;
